import { errorHandler, successHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    list: null,
    major: null,
    totalCount: 0,
    error: "",
    loading: false,
};

export const loadAllMajor = createAsyncThunk(
    "major/loadAllMajor",
    async (arg = {}) => {
        try {
            let query = queryGenerator(arg);
            const { data } = await axios.get(`major?${query}`);
            return successHandler(data);
        } catch (error) {
            return errorHandler(error);
        }
    }
);

export const loadSingleMajor = createAsyncThunk(
    "major/loadSingleMajor",
    async (id) => {
        try {
            const { data } = await axios.get(`major/${id}`);
            return successHandler(data);
        } catch (error) {
            return errorHandler(error);
        }
    }
);

export const createMajor = createAsyncThunk(
    "major/createMajor",
    async (values) => {
        try {
            const { data } = await axios({
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `major`,
                data: values,
            });

            return successHandler(data, "Major Created Successfully");
        } catch (error) {
            return errorHandler(error, true);
        }
    }
);

export const updateMajor = createAsyncThunk(
    "major/updateMajor",
    async ({ id, values }) => {
        try {
            const { data } = await axios({
                method: "put",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `major/${id}`,
                data: values,
            });
            return successHandler(data, "Major Updated Successfully");
        } catch (error) {
            return errorHandler(error);
        }
    }
);

export const deleteMajor = createAsyncThunk(
    "major/deleteMajor",
    async ({ id }) => {
        try {
            const { data } = await axios({
                method: "patch",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `major/${id}`,
            });

            return successHandler(data, "Major deleted successfully");
        } catch (error) {
            return errorHandler(error, true);
        }
    }
);

export const importMajors = createAsyncThunk(
    "major/importMajors",
    async ({ majors }) => {
        try {
            const { data } = await axios({
                method: "post",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=UTF-8",
                },
                url: `major/import`,
                data: { majors },
            });

            return successHandler(data, "Majors Imported Successfully");
        } catch (error) {
            return errorHandler(error, true);
        }
    }
);

const majorSlice = createSlice({
    name: "major",
    initialState,
    reducers: {
        clearMajor: (state) => {
            state.major = null;
        },
        clearMajorList: (state) => {
            state.list = [];
        },
    },
    extraReducers: (builder) => {
        // loadAllMajor
        builder.addCase(loadAllMajor.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(loadAllMajor.fulfilled, (state, action) => {
            state.loading = false;
            const data = action.payload?.data;
            state.list = data?.getAllMajor ?? data;
            state.totalCount = data?.totalMajor ?? data?.length ?? 0;
        });
        builder.addCase(loadAllMajor.rejected, (state) => {
            state.loading = false;
        });

        // loadSingleMajor
        builder.addCase(loadSingleMajor.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(loadSingleMajor.fulfilled, (state, action) => {
            state.loading = false;
            state.major = action?.payload?.data;
        });
        builder.addCase(loadSingleMajor.rejected, (state) => {
            state.loading = false;
        });

        // createMajor
        builder.addCase(createMajor.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createMajor.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload?.data) {
                state.list = [action.payload.data, ...(state.list || [])];
                state.totalCount = (state.totalCount || 0) + 1;
            }
        });
        builder.addCase(createMajor.rejected, (state) => {
            state.loading = false;
        });

        // updateMajor
        builder.addCase(updateMajor.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateMajor.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(updateMajor.rejected, (state) => {
            state.loading = false;
        });

        // deleteMajor
        builder.addCase(deleteMajor.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteMajor.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(deleteMajor.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default majorSlice.reducer;
export const { clearMajor, clearMajorList } = majorSlice.actions;
